import './FactList.module.scss';

// Facts a walker scans, one per line, each led by an icon:
// <FactList><li><Icon aria-hidden="true" /><span>…</span></li></FactList>
const FactList = ({ children }) => <ul className="ts-facts">{children}</ul>;

export default FactList;
